import { Button, Popconfirm, PopconfirmProps } from "antd";
import { Movimentacao } from "../../../../../Models/Financeiro/Conta/Movimentacao";
import { useMovimentacaoDesativar } from "../../../../../Services/Financeiro/Conta/MovimentacaoService";
import { AxiosResponse } from "axios";
import { RenderFunction } from "antd/es/_util/getRenderPropValue";
import { ReactNode } from "react";
import { ButtonProps } from "antd/lib/button";

interface IMovimentacaoDesativarPopconfirmProps extends Omit<PopconfirmProps, "title" | "description"> {
    movimentacao:Movimentacao;
    onSuccess?:(response:AxiosResponse<void, any>, input:Movimentacao) => void;
    title?:ReactNode | RenderFunction;
    description?:ReactNode | RenderFunction;
    openButtonProps?:ButtonProps;
}

export default function MovimentacaoDesativarPopconfirm({
    movimentacao,
    onSuccess,
    title,
    openButtonProps,
    description,
    destroyTooltipOnHide,
    children,
    ...props
}:IMovimentacaoDesativarPopconfirmProps) {
    title = title === undefined ? "Remover movimentação" : title;
    description = description === undefined ? "Tem certeza de que deseja remover esta movimentação?" : description;
    destroyTooltipOnHide = destroyTooltipOnHide ?? true;

    const {
        mutate,
        isPending
    } = useMovimentacaoDesativar({
        onSuccess(data, variables, context) {
            onSuccess?.(data, variables);
        },
    });
    
    return <Popconfirm
        {...props}
        title={title}
        description={description}
        destroyTooltipOnHide={destroyTooltipOnHide}
        onConfirm={() => mutate(movimentacao)}
        okButtonProps={{
            loading : isPending
        }}
    >
        {
            !!children || <Button
                {...openButtonProps}
                type={openButtonProps?.type ?? 'primary'}
                size={openButtonProps?.size ?? 'small'}
                danger={openButtonProps?.danger ?? true}
                style={{ 
                    ...openButtonProps?.style,
                    width : openButtonProps?.style?.width ?? "min-content" 
                }}
            >
                Remover
            </Button>
        }
    </Popconfirm>
}